<template>
  <div>
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.stockIns'), $t('text.list')]"></breadcrumb>
    </div>
    <narrow
      :narrows="narrows"
      :init-filter="initFilter"
      @narrowSelect="narrowSelect"
    />
    <div class="search with-narrows">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-input
            v-model.trim="searchForm.productNo"
            :placeholder="$t('product.productNo')"
            size="small"
          />
        </el-form-item>

        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.remark"
            :placeholder="$t('text.remark')"
          />
        </el-form-item>

        <date-range
          v-model="searchForm"
          type="datetime"
          field="create"
          :start-placeholder="$t('rules.startAt', [$t('text.createAt')])"
          :end-placeholder="$t('rules.endAt', [$t('text.createAt')])"
        />
        <el-form-item>
          <el-input
            v-model.trim="searchForm.associateSerialNo"
            :placeholder="$t('stock.associateSerialNo')"
            size="small"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <sticky
        :sticky-top="62"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar ref="recordsToolbar" custom zoom class="table-toolbar">
          <template v-slot:buttons>
            <el-dropdown @command="download">
              <el-button type="default" size="mini">
                {{ $t("action.download") }}
                <i class="el-icon-caret-bottom el-icon--right" />
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="checked">{{
                  $t("action.downLoadChecked")
                }}</el-dropdown-item>
                <el-dropdown-item command="search">{{
                  $t("action.downLoadSearch")
                }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-button
              class="mgl10"
              type="default"
              size="mini"
              @click="print"
              >{{ $t("action.print") }}</el-button
            >
            <span class="pager-total">
              {{ $t("rules.pagerTotal", [pager.total]) }}，
              {{ pager.productNoQty }} 款 {{ pager.qtyTotal }} 件
            </span>
          </template>
        </vxe-toolbar>
      </sticky>

      <vxe-table
        :data="records"
        @checkbox-change="setSelected"
        @checkbox-all="setSelected"
        :checkbox-config="{ reserve: true }"
        :loading="loading"
        id="stockInsTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        auto-resize
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="checkbox"
          type="checkbox"
          width="35"
        ></vxe-table-column>
        <vxe-table-column
          field="images"
          :title="$t('product.images')"
          width="80"
        >
          <template v-slot="{ row }">
            <thumbnail :images="row.images" />
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="serialNo"
          :title="$t('stock.serialNoIn')"
          min-width="100"
        />
        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.productNo }}
            <div class="font10">
              {{ row.categoryName
              }}<span v-if="row.brand != null">/{{ row.brand }}</span>
            </div>

            <div class="font10">{{ row.color }} {{ row.size }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="quantity"
          :title="$t('text.quantity')"
          min-width="60"
        >
          <template v-slot="{ row }">{{ row.quantity }}{{ row.unit }}</template>
        </vxe-table-column>
        <vxe-table-column
          field="type"
          :title="$t('stock.stockInType')"
          min-width="80"
        >
          <template v-slot="{ row }">
            <span v-if="StockInOut.in_type.includes(row.type)">{{
              $t("stockInType." + row.type)
            }}</span>
            <span v-else>{{ row.type }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="associateSerialNo"
          :title="$t('stock.associateSerialNo')"
          min-width="100"
        />
        <vxe-table-column
          field="shopName"
          :title="$t('menu.shops')"
          min-width="80"
        />
        <vxe-table-column
          field="ownerName"
          :title="$t('stock.ownerIn')"
          min-width="80"
        />
        <vxe-table-column
          field="remark"
          :title="$t('text.remark')"
          min-width="80"
        >
          <template v-slot="{ row }">
            <raw-html-limit-number :content="row.remark" :number="16" />
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="createAt"
          :title="$t('text.createAt')"
          width="110"
        />
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          选中了
          <span class="strong">{{ selectRecordQty }}</span>
          条记录
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>

    <div id="printListDiv" style="display: none">
      <table
        style="
          width: 100%;
          border-collapse: collapse;
          border: 1px solid black;
          word-wrap: break-word;
          word-break: break-all;
          font-size: 10px;
        "
      >
        <tr style="border: 1px solid black">
          <td style="border: 1px solid black; width: 80px">
            {{ $t("stock.serialNoIn") }}
          </td>
          <td style="border: 1px solid black; width: 80px">
            {{ $t("product.productNo") }}
          </td>
          <td style="border: 1px solid black; width: 50px">
            {{ $t("product.category") }}
          </td>
          <td style="border: 1px solid black; width: 60px">
            {{ $t("product.color") }}
          </td>
          <td style="border: 1px solid black; width: 50px">
            {{ $t("product.size") }}
          </td>
          <td style="border: 1px solid black; width: 40px">
            {{ $t("text.quantity") }}
          </td>
          <td style="border: 1px solid black; width: 60px">
            {{ $t("stock.stockInType") }}
          </td>
          <td style="border: 1px solid black; width: 60px">
            {{ $t("stock.associateSerialNo") }}
          </td>
          <td style="border: 1px solid black; width: 60px">
            {{ $t("menu.shops") }}
          </td>
          <td style="border: 1px solid black; width: 60px">
            {{ $t("stock.ownerIn") }}
          </td>
          <td style="border: 1px solid black">{{ $t("text.remark") }}</td>
          <td style="border: 1px solid black; width: 60px">
            {{ $t("text.createAt") }}
          </td>
        </tr>
        <tr
          v-for="(c, index) in selectRecords"
          :key="index"
          style="border: 1px solid black"
        >
          <td style="border: 1px solid black">{{ c.serialNo }}</td>
          <td style="border: 1px solid black">{{ c.productNo }}</td>
          <td style="border: 1px solid black">{{ c.categoryName }}</td>
          <td style="border: 1px solid black">{{ c.color }}</td>
          <td style="border: 1px solid black">{{ c.size }}</td>
          <td style="border: 1px solid black">{{ c.quantity }}</td>
          <td style="border: 1px solid black">
            <span v-if="StockInOut.in_type.includes(c.type)">{{
              $t("stockInType." + c.type)
            }}</span>
            <span v-else>{{ c.type }}</span>
          </td>
          <td style="border: 1px solid black">{{ c.associateSerialNo }}</td>
          <td style="border: 1px solid black">{{ c.shopName }}</td>
          <td style="border: 1px solid black">{{ c.ownerName }}</td>
          <td style="border: 1px solid black">
            <raw-html :content="c.remark" />
          </td>
          <td style="border: 1px solid black">{{ c.createAt }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import { page, table } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import Thumbnail from "@/components/Thumbnail";
import DateRange from "@/components/DateRange";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";
import RawHtml from "@/components/RawHtml";
import Shop from "@/api/shop.js";
import StockInOut from "@/api/stockInOut.js";
import Category from "@/api/category.js";
import Product from "@/api/product.js";
import Brand from "@/api/brand";

export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {
    Thumbnail,
    RawHtmlLimitNumber,
    DateRange,
    RawHtml,
  },
  data() {
    return {
      Util: Util,
      StockInOut: StockInOut,
      narrows: [
        [
          {
            label: this.$t("text.time"),
            items: StockInOut.count_day.map((c) => {
              return {
                key: c,
                label: this.$t("countDay." + c),
                condition: { date: c },
              };
            }),
          },
        ],
      ],

      initFilter: null,
      searchForm: {
        productNo: null,
        remark: null,
        createStartAt: null,
        createEndAt: null,
        shopId: null,
        associateSerialNo: null,
      },
      sorter: {
        sortBy: "stockInOut_id",
        sortIndicator: "desc",
      },
      shops: [],
      shopsView: [],
      categories: [],
    };
  },
  computed: {
    implicit() {
      return {
        direction: "in",
      };
    },
  },
  created() {
    const self = this;
    this.$nextTick(() => {
      // 手动将表格和工具栏进行关联
      this.$refs.recordsTable.connect(this.$refs.recordsToolbar);
    });
    self.initFilter = self.$route.query.initFilter;
    axios
      .all([
        Category.findByTenantId(),
        Brand.findByTenantId(),
        Shop.findByTenantId(),
      ])
      .then(
        axios.spread(function (categories, brands, shops) {
          if (categories.status === 200) {
            self.categories = categories.data;
            if (categories.data.length !== 0) {
              self.narrows.push([
                {
                  label: self.$t("menu.categories"),
                  items: categories.data.map((category) => {
                    return {
                      label: category.name,
                      key: category.name,
                      condition: { categoryId: category.name },
                    };
                  }),
                },
              ]);
            }
          } else {
            self.sysError();
          }
          if (brands.status === 200) {
            if (brands.data.length !== 0) {
              self.narrows.push([
                {
                  label: self.$t("product.brand"),
                  items: brands.data.map((brand) => {
                    return {
                      label: brand.name,
                      key: brand.name,
                      condition: { brand: brand.name },
                    };
                  }),
                },
              ]);
            }
          } else {
            self.sysError();
          }
          if (shops.status === 200) {
            self.shops = shops.data;
            if (self.Permit.currentUser().admin) {
              self.shopsView = self.shops;
            } else {
              self.shopsView = self.shops.filter(
                (s) =>
                  self.Permit.wmsViewShopIds().includes(s.id) &&
                  s.isInventory == true
              );
            }
            if (self.shopsView.length !== 0) {
              self.narrows.push([
                {
                  label: self.$t("menu.shops"),
                  items: self.shopsView.map((shop) => {
                    return {
                      label: shop.name,
                      key: shop.id,
                      condition: { shopId: shop.id },
                    };
                  }),
                },
              ]);
            }
          } else {
            self.sysError();
          }
          const stockInTypes1 = StockInOut.in_type.map((o) => {
            return { key: o, label: self.$t("stockInType." + o) };
          });
          //出入库单类型
          // const stockInTypes2 = customStockInTypes.map((c) => {
          //   return { key: c, label: c };
          // });
          // const stockInTypesAll = stockInTypes1.concat(stockInTypes2);
          self.narrows.push([
            {
              label: self.$t("stock.stockInType"),
              items: stockInTypes1.map((type) => {
                return {
                  label: type.label,
                  key: type.key,
                  condition: { type: type.key },
                };
              }),
            },
          ]);
        })
      );
  },
  methods: {
    //　下载
    download(type) {
      const self = this;
      if (type === "checked") {
        if (
          self.selectRecords.length === 0 ||
          self.selectRecords.length > 100000
        ) {
          self.$message.error(this.$t("prompt.downloadDataRange100000"));
          return;
        }
        const data = {
          currentPage: 1,
          pageSize: 100000,
          ids: self.selectRecords.map((p) => p.id),
          direction: "in",
        };
        self.downloadData(data);
      } else {
        if (self.pager.total === 0 || self.pager.total > 100000) {
          self.$message.error(this.$t("prompt.downloadDataRange100000"));
          return;
        }
        const data = JSON.parse(JSON.stringify(self.combineParams()));
        Vue.set(data, "direction", "in");
        data.pageSize = 100000;
        self.downloadData(data);
      }
    },
    downloadData(data) {
      const self = this;
      StockInOut.exportExcel(data).then(function (res) {
        if (res.data.code === 200) {
          self.$message({
            message: self.$t("prompt.downloadPrompt"),
            type: "success",
          });
          self.$eventHub.$emit("emitDownLoad");
        } else {
          self.$message.error(self.$t("prompt.downloadErr"));
        }
      });
    },

    // 打印
    print() {
      const newWindow = window.open("_blank");
      const codestr = document.getElementById("printListDiv").innerHTML;
      newWindow.document.write(codestr);
      newWindow.document.close();
    },
    //-----
    dataProvider(params) {
      return StockInOut.search(params);
    },
  },
};
</script>
